import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@solar/shared/material.module';
import { BaseComponentsModule } from 'basecomponents';
import {SliderModule} from 'primeng/slider';
import { SliderDlgComponent } from './sliderdlg.component';





@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,MaterialModule
    ,BaseComponentsModule
    ,SliderModule
  ],
  declarations: [
    SliderDlgComponent
  ],
  exports: [
    SliderDlgComponent
  ]
  , entryComponents: []

  , providers: [

  ]
})
export class SliderDlgModule { }
